import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Boutique = lazy(() => import('../pages/boutique/page'));
const Produit = lazy(() => import('../pages/produit/page'));
const Panier = lazy(() => import('../pages/panier/page'));
const Commande = lazy(() => import('../pages/commande/page'));
const Confirmation = lazy(() => import('../pages/confirmation/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminProduits = lazy(() => import('../pages/admin/produits/page'));
const AdminCommandes = lazy(() => import('../pages/admin/commandes/page'));
const AdminStock = lazy(() => import('../pages/admin/stock/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/boutique',
    element: <Boutique />
  },
  {
    path: '/produit/:id',
    element: <Produit />
  },
  {
    path: '/panier',
    element: <Panier />
  },
  {
    path: '/commande',
    element: <Commande />
  },
  {
    path: '/confirmation',
    element: <Confirmation />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />
  },
  {
    path: '/admin/produits',
    element: <AdminProduits />
  },
  {
    path: '/admin/commandes',
    element: <AdminCommandes />
  },
  {
    path: '/admin/stock',
    element: <AdminStock />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;